import { Button, Grid, Paper } from "@mui/material";
import { Form, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fieldInitialValues } from "../../config/fieldIntialValues";
import ActivitiesFertilizerComponent from "./ActivitiesFertilizer.component";
import ActivitiesIrrigationComponent from "./ActivitiesIrrigation.component";
import ActivitiesPesticideComponent from "./ActivitiesPesticide.component";
import ActivitiesSoilPreparationComponent from "./ActivitiesSoilPreparation.component";
import CropFormComponent from "./CropForm.component";
import IrrigationFormComponent from "./IrrigationForm.component";
import SensorsFormComponent from "./SensorsForm.component";
import SoilTypeFormComponent from "./SoilTypeForm.component";
import { fetchWeatherStationsRequest } from "../../store/actions/weatherStations.action";
import GeneralInfoFormComponent from "./GeneralInfoForm.component";
import { validationSchema } from "../../schemas/fieldFormSchema";

const FieldFormComponent = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isWaterCounterPresent, setIsWaterCounterPresent] = useState(false);

  const fieldSelected = useSelector((state) => state.field.data);
  const field = useSelector((state) => state.fields.data).find(
    (f) => f.id === fieldSelected,
  );
  const [newSystem, setNewSystem] = useState(field?.irrigations_system?.system);
  const weatherStations = useSelector((state) => state?.weatherStations?.data);

  const [weatherStation, setWeatherStation] = useState(
    props.addNew ? "" : field?.weather_station?.id,
  );

  const handleChange = (event) => {
    setWeatherStation(event.target.value);
  };

  useEffect(() => {
    if (field && field.sensors && Array.isArray(field.sensors)) {
      const hasWaterCounter = field.sensors.some(
        (sensor) => sensor.type === "water_counter",
      );
      setIsWaterCounterPresent(hasWaterCounter);
    }
  }, [field]);

  useEffect(() => {
    if (!weatherStations || weatherStations.length === 0) {
      dispatch(fetchWeatherStationsRequest());
    }
  }, [dispatch, weatherStations]);

  const initialValues = props.addNew ? fieldInitialValues : field;

  return (
    <Fragment>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <Formik
            initialValues={initialValues}
            validate={(values) => {
              try {
                validationSchema(t).validateSync(values, {
                  abortEarly: false,
                  context: {
                    fieldArea: values?.totalArea,
                    crop: {
                      distance_individuals: values?.crop?.distance_individuals,
                    },
                  },
                });
                return {};
              } catch (error) {
                const errors = {};
                if (error.inner) {
                  error.inner.forEach((e) => {
                    const path = e.path;
                    if (path.includes(".")) {
                      const parts = path.split(".");
                      let current = errors;
                      for (let i = 0; i < parts.length - 1; i++) {
                        if (!current[parts[i]]) {
                          current[parts[i]] = {};
                        }
                        current = current[parts[i]];
                      }
                      if (!current[parts[parts.length - 1]]) {
                        current[parts[parts.length - 1]] = e.message;
                      }
                    } else {
                      if (!errors[path]) {
                        errors[path] = e.message;
                      }
                      console.log("Errors parsed:", errors);
                      return errors;
                    }
                  });
                }
                return errors;
              }
            }}
            onSubmit={(values) => {
              props.onSubmit({
                ...values,
                weather_station: weatherStation || null,
                climate_zone: values.soil_type?.climate_zone || null,
              });
            }}
          >
            {(formikProps) => (
              <Form>
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item xs={12}>
                    <div>
                      <h3>{t("field_form.title")}</h3>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper
                      variant="outlined"
                      sx={{ height: "100%", padding: "20px" }}
                    >
                      <GeneralInfoFormComponent
                        formikProps={formikProps}
                        weatherStation={weatherStation}
                        handleChange={handleChange}
                        weatherStations={weatherStations}
                      />
                    </Paper>
                  </Grid>
                  {!props.addNew && (
                    <Grid item xs={12}>
                      <div>
                        <h3>{t("activities")}</h3>
                      </div>
                      <Grid container spacing={2}>
                        {!isWaterCounterPresent && (
                          <Grid item xs={12} sm={12} md={6}>
                            <Paper
                              variant="outlined"
                              sx={{
                                height: "100%",
                                paddingX: "20px",
                                paddingBottom: "20px",
                              }}
                            >
                              <ActivitiesIrrigationComponent
                                formikProps={formikProps}
                                irrigationSystem={newSystem}
                              ></ActivitiesIrrigationComponent>
                            </Paper>
                          </Grid>
                        )}

                        <Grid item xs={12} sm={12} md={6}>
                          <Paper
                            variant="outlined"
                            sx={{
                              height: "100%",
                              paddingX: "20px",
                              paddingBottom: "20px",
                            }}
                          >
                            <ActivitiesSoilPreparationComponent
                              formikProps={formikProps}
                            ></ActivitiesSoilPreparationComponent>
                          </Paper>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6}>
                          <Paper
                            variant="outlined"
                            sx={{
                              height: "100%",
                              paddingX: "20px",
                              paddingBottom: "20px",
                            }}
                          >
                            <ActivitiesFertilizerComponent
                              formikProps={formikProps}
                            ></ActivitiesFertilizerComponent>
                          </Paper>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6}>
                          <Paper
                            variant="outlined"
                            sx={{
                              height: "100%",
                              paddingX: "20px",
                              paddingBottom: "20px",
                            }}
                          >
                            <ActivitiesPesticideComponent
                              formikProps={formikProps}
                            ></ActivitiesPesticideComponent>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Paper
                      variant="outlined"
                      sx={{
                        height: "100%",
                        paddingX: "20px",
                        paddingBottom: "20px",
                      }}
                    >
                      <IrrigationFormComponent
                        formikProps={formikProps}
                        onSystemChange={(newSystem) => setNewSystem(newSystem)}
                      ></IrrigationFormComponent>
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper
                      variant="outlined"
                      sx={{
                        height: "100%",
                        paddingX: "20px",
                        paddingBottom: "20px",
                      }}
                    >
                      <SoilTypeFormComponent
                        formikProps={formikProps}
                      ></SoilTypeFormComponent>
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper
                      variant="outlined"
                      sx={{
                        height: "100%",
                        paddingX: "20px",
                        paddingBottom: "20px",
                      }}
                    >
                      <CropFormComponent
                        formikProps={formikProps}
                        isUpdateMode={props.isUpdateMode}
                      ></CropFormComponent>
                    </Paper>
                  </Grid>
                  {!props.addNew && (
                    <Grid item xs={12}>
                      <div>
                        <h3>{t("sensor")}</h3>
                      </div>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Paper
                            variant="outlined"
                            sx={{
                              height: "100%",
                              paddingX: "20px",
                              paddingBottom: "10px",
                            }}
                          >
                            <SensorsFormComponent
                              formikProps={formikProps}
                            ></SensorsFormComponent>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      sx={{
                        position: "fixed",
                        bottom: "50px",
                        left: "55%",
                        transform: "translateX(-50%)",
                        zIndex: 1000,
                        boxShadow: 10,
                        height: "55px",
                      }}
                    >
                      {props.addNew ? t("add_field") : t("update_field")}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default FieldFormComponent;
